import { render, staticRenderFns } from "./ErrorForm.vue?vue&type=template&id=00891f04&scoped=true&"
import script from "./ErrorForm.vue?vue&type=script&lang=js&"
export * from "./ErrorForm.vue?vue&type=script&lang=js&"
import style0 from "./ErrorForm.vue?vue&type=style&index=0&id=00891f04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00891f04",
  null
  
)

export default component.exports